export default {
  fetchingCurrencyConversionRates: true,
  uploadingCurrencyConversionRates: false,
  importingCurrencyConversionRates: false,
  importingCurrencyConversionRatesProgress: 0,
  isSavingInProgress: false,
  isRemovingInProgress: false,
  currencyConversionRates: [],
  missingRates: [],
  currencyOptions: [],
  extendedUploadedCurrencyConversionRates: [],
  importStats: {},
};
